module.exports = __webpack_public_path__ + "media/images/nav_shose-67a2630e896bbd649e583a7372831850.jpg";